import axios from "axios";
import { toast } from "react-toastify";
import * as actionTypes from "./ActionTypes";

// get all reports 
export const GetReportsList = ({ search = "", page = 1 }) =>
    async (dispatch) => {
        dispatch({
            type: actionTypes.REPORTS_LIST_INIT,
        });

        try {
            const authToken = localStorage.getItem("authToken");
            const config = {
                headers: {
                    Authorization: authToken ? `Bearer ${authToken}` : "",
                },
            };
            const response = await axios.get(
                `https://app.loungebridge.com/api/admin/reports?search=${search}&page=${page}`,
                config
            );

            if (response.status === 200) {
                dispatch({
                    type: actionTypes.REPORTS_LIST_SUCCESS,
                    payload: response.data,
                });
            } else {
                dispatch({
                    type: actionTypes.REPORTS_LIST_FAIL,
                    payload: "Failed to fetch records",
                });
                toast.error("Failed to fetch records");
                return false;
            }
        } catch (error) {
            if (error.response?.status === 401 || error.response?.status === 403) {
                localStorage.removeItem("authToken");
                toast.error("Session expired. Please log in again.");
                window.location.href = "/login"; 
            } else {
                dispatch({
                    type: actionTypes.REPORTS_LIST_FAIL,
                    payload: error.response ? error.response.data : "An error occurred",
                });
                toast.error("Failed to fetch users");
            }
            return false;
        }
    };